import { axiosClient } from '../../clients/axios-client'
import type { FileDeleteResponseDto } from './dtos/file'
import { FileDeleteResponseDtoSchema } from './dtos/file'

export interface DeleteFileResponseType {
  isDeleted: boolean
}

export async function deleteFileById(fileId: string): Promise<DeleteFileResponseType> {
  if (!fileId?.trim()) {
    throw new Error('File ID is required')
  }

  try {
    const { data } = await axiosClient.delete<FileDeleteResponseDto>(`/filepool/files/${fileId}`)

    const { success, message } = FileDeleteResponseDtoSchema.parse(data)
    if (!success) {
      throw new Error(`File deletion failed with the following message: ${message}`)
    }

    return {
      isDeleted: true,
    }
  } catch (error) {
    console.error(`File deletion failed. File ID: ${fileId}`, error)
    throw error
  }
}
